import Loadable from 'react-loadable';
import LoadingMask from 'components/LoadingMask';

export default Loadable({
  loader: () => import('./index'),
  loading: LoadingMask,
});



// WEBPACK FOOTER //
// ./src/containers/2025budapest/Loadable.js